export default __webpack_public_path__ + "static/media/DSC_0548.6b979a63.webp";